import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Bell } from "lucide-react";
import { API } from "../config";
import { tx } from "../lib/tx";

const EVENT = "lc:unread";

// Interroge le serveur toutes les 15 s et diffuse les compteurs non lus (badges + toast)
export default function RealtimeNotifier() {
  const navigate = useNavigate();
  const lastId = useRef(null);

  useEffect(() => {
    let alive = true;
    const tick = async () => {
      const token = localStorage.getItem("session_token");
      if (!token) return;
      try {
        const r = await fetch(`${API}/notifications/unread-counts`, { headers: { Authorization: `Bearer ${token}` } });
        if (!r.ok || !alive) return;
        const d = await r.json();
        window.__lcUnread = d;
        window.dispatchEvent(new CustomEvent(EVENT, { detail: d }));
        const id = d.latest?.notification_id || "";
        if (lastId.current !== null && id && id !== lastId.current) {
          toast(d.latest.message, {
            action: { label: tx("Voir"), onClick: () => navigate(d.latest.type === "message" ? `/chat/${d.latest.from_user_id}` : "/notifications") },
          });
        }
        lastId.current = id;
      } catch {
        /* réseau indisponible : prochain tick */
      }
    };
    tick();
    const iv = setInterval(tick, 15000);
    const onVisible = () => document.visibilityState === "visible" && tick();
    document.addEventListener("visibilitychange", onVisible);
    return () => { alive = false; clearInterval(iv); document.removeEventListener("visibilitychange", onVisible); };
  }, [navigate]);

  return null;
}

export function useUnread() {
  const [counts, setCounts] = useState(window.__lcUnread || {});
  useEffect(() => {
    const h = (e) => setCounts(e.detail || {});
    window.addEventListener(EVENT, h);
    return () => window.removeEventListener(EVENT, h);
  }, []);
  return counts;
}

export function NotificationBell() {
  const navigate = useNavigate();
  const unread = useUnread();
  return (
    <button
      onClick={() => navigate("/notifications")}
      className="relative h-9 w-9 rounded-full border border-white/15 bg-white/5 flex items-center justify-center text-white hover:border-primary/50 transition-colors"
      data-testid="notifications-bell-btn"
      aria-label="Notifications"
    >
      <Bell className="w-4 h-4" />
      <CountBadge count={unread.notifications} testId="notifications-bell-badge" />
    </button>
  );
}

export function CountBadge({ count, testId }) {
  if (!count) return null;
  return (
    <span data-testid={testId} className="absolute -top-1 -right-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-primary text-white text-[10px] font-bold flex items-center justify-center ring-2 ring-black">
      {count > 99 ? "99+" : count}
    </span>
  );
}
